import { useCalculateFetchedItems } from '../../../../hooks/useCalculateFetchItems';
import { useScrollFetchData } from '../../../../hooks/useScrollFetchData';
import MachineContractCardViewData from './machineContractCardViewData';
import { useMediaQuery, useTheme } from '@mui/material';
import { PersistedFixedSizeList as List } from "../../../../hooks/listNavigation";
import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';

const MachineContractGridView = React.memo(({ setOffset, scrollRef, contracts, filteredRecordCount, setFetchedContracts }) => {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));

    // Determine the number of columns based on screen size
    const getColumns = () => {
        if (isXs) return 1;
        if (isSm) return 2;
        if (isMd) return 3;
        if (isLg) return 4;
        if (isXl) return 4;
        return 5; // Default
    };

    const columns = getColumns();

    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    // Update window height on resize
    useEffect(() => {
        const handleResize = debounce(() => {
            setWindowHeight(window.innerHeight);
        }, 300); // 300ms debounce delay

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            handleResize.cancel(); // Cancel any pending debounced calls
        };
    }, []);

    // Calculate the number of rows based on the number of machines and columns
    const rowCount = Math.ceil(filteredRecordCount / columns);

    // Calculate fetched items on mount
    useCalculateFetchedItems(filteredRecordCount, setFetchedContracts, 400, 215, columns);

    // Handle scroll and fetch more items
    const handleScroll = useScrollFetchData(setOffset, setFetchedContracts, filteredRecordCount, 400, 215, columns);

    const Row = ({ index, style, data }) => {
        const { contracts, columns, filteredRecordCount } = data;
        return (
            <div key={index} style={style}>
                <MachineContractCardViewData
                    index={index}
                    data={{ contracts, columns, filteredRecordCount }}
                />
            </div>
        );
    };

    return (
        <List
            ref={scrollRef}
            height={windowHeight - 400}
            width='100%'
            itemCount={rowCount}
            itemSize={390}
            itemData={{ contracts, columns, filteredRecordCount }}
            onScroll={handleScroll}
        >
            {Row}
        </List>
    );
});

export default MachineContractGridView;